import React, { useEffect, useRef } from 'react';

function ModalSelectCompany({ open, onClose, companies, onSelect }) {
  const boxRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    // foco para acessibilidade
    try {
      boxRef.current?.setAttribute('tabindex', '-1');
      boxRef.current?.focus();
    } catch {
      // Melhor esforço apenas; falha de foco nao deve bloquear o modal.
    }
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleOverlayClick = () => onClose?.();

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-select-company-title"
        ref={boxRef}
      >
        <h3 id="modal-select-company-title">Escolha a Empresa</h3>

        <ul className="modal-list">
          <li className="modal-list-item">
            <button
              type="button"
              className="btn btn-light modal-list-button"
              onClick={() => onSelect?.(null)}
            >
              Sem empresa selecionada
            </button>
          </li>
          {Array.isArray(companies) && companies.map((c) => (
            <li key={c.id} className="modal-list-item">
              <button
                type="button"
                className="btn btn-light modal-list-button"
                onClick={() => onSelect?.(c)}
              >
                {c.name}
              </button>
            </li>
          ))}
        </ul>

        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalSelectCompany;
